import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';
import { barcodeService, type BarcodeLabelRow } from '@/services/BarcodeService';

export type { BarcodeLabelRow };

export const barcodeKeys = {
  all: ['barcodes'] as const,
  list: () => [...barcodeKeys.all, 'list'] as const,
};

export const useAllBarcodeMappings = () => {
  return useQuery({
    queryKey: barcodeKeys.list(),
    queryFn: () => barcodeService.getAllMappings(),
  });
};

export const useCreateBarcodeMapping = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ catalogId, locationId }: { catalogId: string; locationId: string }) =>
      barcodeService.createMappingManual(catalogId, locationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: barcodeKeys.list() });
    },
  });
};

export const useDeleteBarcodeMapping = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ mappingId }: { mappingId: string }) => barcodeService.deleteMapping(mappingId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: barcodeKeys.list() });
    },
  });
};
